import AdvancedReact from "./Images/Certifications/AdvancedReact.webp";
import img2 from "./Images/Certifications/CodeCamp.jpeg";
import CodeJam2021 from "./Images/Certifications/CodeJam2021.webp";
import CodeMania from "./Images/Certifications/CodeMania.webp";
import MakerspaceProgram from "./Images/Certifications/MakerspaceProgram.webp";
import ReactBasic from "./Images/Certifications/ReactBasic.webp";
import Uom1_PythonBeginner from "./Images/Certifications/Uom/Uom1_PythonBeginner.png";
import Uom2_WebDesign from "./Images/Certifications/Uom/Uom2_WebDesign.png";
import Uom3_PythonProgramming from "./Images/Certifications/Uom/Uom3_PythonProgramming.png";
import Uom4_FrontEndWebDevelopment from "./Images/Certifications/Uom/Uom4_FrontEndWebDevelopment.png";
import Uom5_ServerSideWebProgramming from "./Images/Certifications/Uom/Uom5_ServerSideWebProgramming.png";
import Uom6_ProfessionalPracticeInSoftwareDevelopment from "./Images/Certifications/Uom/Uom6_ProfessionalPracticeInSoftwareDevelopment.png";

const CertificationsData = [
  {
    id: 1,
    category: "Web",
    categoryLink: "fab fa-chrome",
    tag: "Course",
    tagLink: "fab fa-react",
    image: AdvancedReact,
    title: "AdvancedReact",
    icon1: "fas fa-file-image",
    icon2: "fas fa-code-branch",
    link: "https://coursera.org/verify/RG8GDVEZTVV8",
    text: "Coursera | Credential ID: RG8GDVEZTVV8",
  },
  {
    id: 2,
    category: "Web",
    categoryLink: "fab fa-chrome",
    tag: "Course",
    tagLink: "fab fa-react",
    image: ReactBasic,
    title: "ReactBasic",
    icon1: "fas fa-file-image",
    icon2: "fas fa-code-branch",
    link: "https://coursera.org/verify/GJT85957E5H9",
    text: "Coursera | Credential ID: GJT85957E5H9",
  },
  {
    id: 3,
    category: "Coding",
    categoryLink: "fas fa-code",
    tag: "Project",
    tagLink: "fas fa-code",
    image: CodeJam2021,
    title: "Code Jam 2021",
    icon1: "fas fa-file-image",
    icon2: "fas fa-code-branch",
    link: "#",
    text: "For my accomplishment in Code Jam 2021",
  },
  {
    id: 4,
    category: "Coding",
    categoryLink: "fas fa-code",
    tag: "Project",
    tagLink: "fab fa-python",
    image: Uom1_PythonBeginner,
    title: "Python for Beginners",
    icon1: "fas fa-file-image",
    icon2: "fas fa-code-branch",
    link: "https://open.uom.lk/verify",
    text: "CODL University of Moratuwa, Sri Lanka | Verification Code: 4ZF4IkA927",
  },
  {
    id: 5,
    category: "Coding",
    categoryLink: "fas fa-code",
    tag: "Project",
    tagLink: "fab fa-chrome",
    image: Uom2_WebDesign,
    title: "Web Design for Beginners",
    icon1: "fas fa-file-image",
    icon2: "fas fa-code-branch",
    link: "https://open.uom.lk/verify",
    text: "CODL University of Moratuwa, Sri Lanka | Verification Code: zNDk54wiPe",
  },
  {
    id: 6,
    category: "Coding",
    categoryLink: "fas fa-code",
    tag: "Project",
    tagLink: "fab fa-python",
    image: Uom3_PythonProgramming,
    title: "Python Programming",
    icon1: "fas fa-file-image",
    icon2: "fas fa-code-branch",
    link: "https://open.uom.lk/verify",
    text: "CODL University of Moratuwa, Sri Lanka | Verification Code: cZB4NumShS",
  },
  {
    id: 7,
    category: "Coding",
    categoryLink: "fas fa-code",
    tag: "Project",
    tagLink: "fab fa-chrome",
    image: Uom4_FrontEndWebDevelopment,
    title: "Front-End Web Development",
    icon1: "fas fa-file-image",
    icon2: "fas fa-code-branch",
    link: "https://open.uom.lk/verify",
    text: "CODL University of Moratuwa, Sri Lanka | Verification Code: uSKz4I8GQS",
  },
  {
    id: 8,
    category: "Coding",
    categoryLink: "fas fa-code",
    tag: "Project",
    tagLink: "fab fa-chrome",
    image: Uom5_ServerSideWebProgramming,
    title: "Server-side Web Programming",
    icon1: "fas fa-file-image",
    icon2: "fas fa-code-branch",
    link: "https://open.uom.lk/verify",
    text: "CODL University of Moratuwa, Sri Lanka | Verification Code: cy3uiYzVwc",
  },
  {
    id: 9,
    category: "Coding",
    categoryLink: "fas fa-code",
    tag: "Project",
    tagLink: "fas fa-code",
    image: Uom6_ProfessionalPracticeInSoftwareDevelopment,
    title: "Professional Practice in Software Development",
    icon1: "fas fa-file-image",
    icon2: "fas fa-code-branch",
    link: "https://open.uom.lk/verify",
    text: "CODL University of Moratuwa, Sri Lanka | Verification Code: qr7aKwPHUy",
  },
  {
    id: 10,
    category: "Python",
    categoryLink: "fab fa-python",
    tag: "Course",
    tagLink: "fas fa-code",
    image: CodeMania,
    title: "Road to CodeMania",
    icon1: "fas fa-file-image",
    icon2: "fas fa-code-branch",
    link: "#",
    text: "IEEESLTC_RCM_183 Road to CodeMania’21 Python Fundamentals & Algorithmic Programming",
  },
  {
    id: 11,
    category: "Arduino",
    categoryLink: "fas fa-project-diagram",
    tag: "Course",
    tagLink: "fas fa-project-diagram",
    image: MakerspaceProgram,
    title: "MAKERSPACE PROGRAM",
    icon1: "fas fa-file-image",
    icon2: "fas fa-code-branch",
    link: "#",
    text: "(An online six week Program) | Conducted by: The American Center Colombo | August , 2021",
  },
  // {
  //   id: 12,
  //   category: "Arduino",
  //   categoryLink: "fas fa-project-diagram",
  //   tag: "Project",
  //   tagLink: "fas fa-project-diagram",
  //   image: img2,
  //   title: "Arduino Codecamp Workshop",
  //   icon1: "fas fa-file-image",
  //   icon2: "fas fa-code-branch",
  //   link: "#",
  //   text: "For Successfully Completing Arduino Codecamp Workshop | Credential ID: CC16254688",
  // },
];

export default CertificationsData;
